import React, { useEffect, useState } from "react";
import axios from "axios";
import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import InventoryNav from "../components/inventoryNav";
import Time from "../components/time";
import { Link } from "react-router-dom";

const Branch_pr = () => {
    useAuthRedirect();
const [data, setData] = useState([]);
const branch = localStorage.getItem("branch");
const [filteredData, setFilteredData] = useState([]);
const [searchTerm, setSearchTerm] = useState("");
const [currentPage, setCurrentPage] = useState(1);
const [itemsPerPage] = useState(10);
const [loading, setLoading] = useState(false);

/////////////////////////////////////////////////////////////     
          //✅ Permission checks (safe even if perms not yet loaded; will be false)
          const canView  = hasPermission("Branch office Requisition", "view");
          const canEntry = hasPermission("Branch office Requisition", "entry");
          const canEdit = hasPermission("Branch office Requisition", "edit");
          /////////////////////////////////////////////////////////////
     

useEffect(() => {
    fetchData();
}, [branch]);

const fetchData = async () => {
    setLoading(true);
    try {
    const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/bo_list?branch=${branch}`);
    setData(response.data.BOlist);
    setFilteredData(response.data.BOlist);
    } catch (error) {
    console.error("Error fetching BOlist:", error);
    } finally {
    setLoading(false);
    }
};

const handleSearch = (e) => {
    const term = e.target.value.toLowerCase();
    setSearchTerm(term);

    if (term === "") {
        setFilteredData(data);
        return;
    }

    const filtered = data.filter((item) => 
        String(item.prHeader_number || "").toLowerCase().includes(term) || 
    String(item.departmentmaster_name || "").toLowerCase().includes(term) || 
    String(item.prHeader_hod || "").toLowerCase().includes(term) || 
        String(item.supplierMaster_name || "").toLowerCase().includes(term)
    );

    setFilteredData(filtered);
};

if (!canView) {
    return (
      <div id="admin-container">
        <InventoryNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }


// Pagination
const paginate = (pageNumber) => setCurrentPage(pageNumber);
const indexOfLastItem = currentPage * itemsPerPage;
const indexOfFirstItem = indexOfLastItem - itemsPerPage;
const currentData = filteredData.slice(indexOfFirstItem, indexOfLastItem);

return (
    <div id="admin-container">
    <InventoryNav />
    <div className="content-right">
        <section>
        <h2 className="add-txt">Branch Office Purchase Requisition
        </h2>
        <Time />
        </section>

{canEntry && (
        <div className="next-container">
        <Link to={`/inventory/miscPoView`}>
            <button className="next-btn">
            Next BO Purchase Order<i className="fa-solid fa-arrow-right"></i> 
            </button>
        </Link>
        </div>
)}

          {/* Add New Button */}
          {canEntry && (
                <div className="add-new-container">
                  <Link to={`/inventory/mis_AddPr`}>
                    <button className="add-new-btn">
                      <i className="fa-solid fa-plus"></i> Add New
                    </button>
                  </Link>
                </div>
          )}

        {/* Search Filter */}
        <div className="search-filter">
        <p>Search: </p>
        <input
            type="text"
            placeholder="Search by Req No"
            value={searchTerm}
            onChange={handleSearch}
            className="search-input"
        />
        </div>

        {/* Table */}
        <div className="content-table">
        <table>
            <thead>
            <tr>
                <th>S.No</th>
                <th>Req No</th>
                <th>Date</th>
                <th>Department</th>
                <th>H.O.D</th>
                <th>Supplier Name</th>
                {canEdit && (
                <th>Modify</th>
                )}
            </tr>
            </thead>
            <tbody>
            {loading ? (
                <tr>
                <td colSpan="6" className="loading-text">Loading data, please wait...</td>
                </tr>
            ) : currentData.length > 0 ? (
                currentData.map((item, index) => (
                <tr key={index}>
                    <td>{indexOfFirstItem + index + 1}</td>
                    <td>
                    <Link to={`/inventory/mis_PrViewSingle/${item.prHeader_number}/${item.prDetail_supplierCode}`}>
                        {item.prHeader_number}
                    </Link>
                    </td>
                    <td>{new Date(item.prHeader_date).toLocaleDateString()}</td>
                    <td>{item.departmentmaster_name}</td>
                    <td>{item.prHeader_hod}</td>
                    <td>{item.supplierMaster_name}</td>
                    {canEdit && (
                    <td>
                    <Link to={`/inventory/mis_ModifyPr/${item.prHeader_number}/${item.prDetail_supplierCode}`}>
                        Modify
                    </Link>
                    </td>
                    )}
                </tr>
                ))
            ) : (
                <tr>
                <td colSpan="6">No Data Available</td>
                </tr>
            )}
            </tbody>
        </table>
        </div>

        {/* Pagination */}
        <div className="pagination">
        <button onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}>
            Previous
        </button>

        {/* Always show first page */}
        <button onClick={() => paginate(1)} className={currentPage === 1 ? 'active' : ''}>
            1
        </button>

        {/* Show up to 3 pages dynamically */}
        {filteredData.length > 0 &&
            [...Array(Math.min(3, Math.ceil(filteredData.length / itemsPerPage) - 1))].map((_, index) => {
            const pageNumber = currentPage + index;
            if (pageNumber > 1 && pageNumber <= Math.ceil(filteredData.length / itemsPerPage)) {
                return (
                <button key={pageNumber} onClick={() => paginate(pageNumber)} className={currentPage === pageNumber ? 'active' : ''}>
                    {pageNumber}
                </button>
                );
            }
            return null;
            })
        }

        {/* Next button */}
        <button onClick={() => paginate(currentPage + 1)} disabled={currentPage === Math.ceil(filteredData.length / itemsPerPage)}>
            Next
        </button>
        </div>
    </div>
    </div>
);
};

export default Branch_pr;
